<template>
  <div class="height-full">
    <a-row class="m-b-10" :gutter="10">
      <a-col :xs="6" :sm="6" :md="4" :lg="3" :xl="2" :xxl="2">
        <LevleSelect v-model="level" />
      </a-col>
      <a-col :xs="8" :sm="8" :md="7" :lg="5" :xl="5" :xxl="5">
        <a-input addon-before="名称" v-model="name" placeholder="搜索内容">
          <a-icon slot="suffix" type="search" />
        </a-input>
      </a-col>
      <a-col :xs="8" :sm="8" :md="7" :lg="5" :xl="5" :xxl="5">
        <DateRangePicker label="创建时间" v-model="rangeValue" />
      </a-col>
      <a-col
        :xs="{ span: 2, offset: 0 }"
        :sm="{ span: 2, offset: 0 }"
        :md="{ span: 2, offset: 4 }"
        :lg="{ span: 2, offset: 9 }"
        :xl="{ span: 2, offset: 10 }"
        :xxl="{ span: 2, offset: 10 }"
        class="text-right"
      >
        <a-button
          type="primary"
          @click="addData"
          v-if="can('createGrainWarehouseModel')"
        >
          新建
        </a-button>
      </a-col>
    </a-row>
    <div class="height-full">
      <tk-flex class="height-full" center middle v-if="isEmpty">
        <a-empty />
      </tk-flex>
      <div class="width-full height-full" v-else>
        <div class="min-heiget-90">
          <a-row :gutter="[16, 16]" type="flex">
            <a-col
              v-for="item in datas"
              :key="item.objectId"
              :xs="24"
              :sm="24"
              :md="12"
              :lg="12"
              :xl="8"
              :xxl="8"
            >
              <WaredepotCard
                :warehouse="item"
                @edit="reset"
                @delete="reset"
                @click="jump(item)"
              />
            </a-col>
          </a-row>
        </div>
        <tk-flex class="m-t-20" right>
          <a-pagination
            show-quick-jumper
            v-model="current"
            :pageSize.sync="pageSize"
            :pageSizeOptions="['9', '12', '15', '18']"
            showSizeChanger
            :total="total"
            @change="onChange"
            @showSizeChange="onShowSizeChange"
          />
        </tk-flex>
      </div>
    </div>
    <a-modal
    :maskClosable="false"
      title="新增粮库"
      :visible="showAdd"
      :confirm-loading="confirmAddLoading"
      @ok="handleAddOk"
      destroyOnClose
      @cancel="handleAddCancel"
    >
      <ak-inputs v-model="formdata" :options="options" ref="inputs" />
    </a-modal>
  </div>
</template>
<script>
import { notEmpty, isPhone } from '../../utils/validator'
import { mapGetters } from 'vuex'
import WaredepotCard from '../../components/waredepot/card'
import LevleSelect from '../../components/levleSelect'
import DateRangePicker from '../../components/dateRangePicker'
import moment from 'moment'
import { getAddressAllAdcode } from '../../utils/adcode.js'
export default {
  components: {
    WaredepotCard,
    LevleSelect,
    DateRangePicker
  },
  data () {
    return {
      // add modal
      options: [
        {
          name: 'hierarchy',
          note: '所属层级',
          type: 'Pointer',
          validators: [notEmpty()],
          span: 24,
          targetClass: 'hierarchy',
          searchKey: ['name'],
          listWhere: where => {
            where.tag = {
              $regex: `^${this.userLevelTag}`
            }
          }
        },
        {
          name: 'name',
          note: '粮库名称',
          type: 'String',
          validators: [notEmpty()]
        },
        {
          name: 'wheelMan',
          note: '负责人',
          type: 'String',
          validators: [notEmpty()]
        },
        {
          name: 'wheelManPhone',
          note: '负责人电话',
          type: 'String',
          validators: [notEmpty(), isPhone()]
        },
        {
          name: 'contacter',
          note: '联系人',
          type: 'String',
          validators: [notEmpty()]
        },
        {
          name: 'contacterPhone',
          note: '联系人电话',
          type: 'String',
          validators: [notEmpty(), isPhone()]
        },
        {
          name: 'address',
          note: '地址',
          type: 'Region',
          validators: [notEmpty()]
        },
        {
          name: 'detailedAddress',
          note: '详细地址',
          type: 'String',
          validators: [notEmpty()]
        }
      ],
      showAdd: false,
      confirmAddLoading: false,
      formdata: {},
      // list + page
      datas: [],
      total: 0,
      pageSize: 9,
      current: 1,
      // filter
      name: null,
      level: undefined,
      rangeValue: []
    }
  },
  computed: {
    ...mapGetters(['userLevelTag']),
    isEmpty () {
      return this.datas && this.datas.length === 0
    },
    filterObj () {
      const json = {}
      if (this.name) {
        json['name'] = { $regex: this.name }
      }
      if (this.rangeValue && this.rangeValue.length > 0) {
        json['createdAt'] = {
          $gt: moment(this.rangeValue[0])
            .startOf('day')
            .toISOString(),
          $lte: moment(this.rangeValue[1])
            .endOf('day')
            .toISOString()
        }
      }
      if (!this.level) {
        json['hierarchy'] = {
          $inQuery: {
            where: {
              tag: { $regex: '^' + this.userLevelTag }
            },
            className: 'hierarchy'
          }
        }
      } else {
        json['hierarchy'] = {
          $inQuery: {
            where: {
              tag: { $regex: '^' + this.level }
            },
            className: 'hierarchy'
          }
        }
      }
      return json
    }
  },
  watch: {
    filterObj () {
      this.current = 1
      this.init()
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    jump (item) {
      this.$router.push({
        path: '/grainstore',
        query: { depot: item.objectId, hid: item.hierarchy }
      })
    },
    async handleAddOk () {
      this.confirmLoading = true
      await this.submit()
      this.showAdd = false
      this.confirmLoading = false
      this.reset()
    },
    handleAddCancel () {
      this.showAdd = false
    },
    addData () {
      this.formdata = {}
      this.showAdd = true
      this.confirmLoading = false
    },
    async submit () {
      const errors = await this.$refs.inputs.validate()
      if (!Object.keys(errors).length) {
        const { cityCode, provinceCode } = await getAddressAllAdcode(
          this.formdata.address
        )
        await this.$tkParse.post('/classes/grainWarehouse', {
          hierarchy: this.formdata.hierarchy,
          name: this.formdata.name,
          wheelMan: this.formdata.wheelMan,
          wheelManPhone: this.formdata.wheelManPhone,
          contacter: this.formdata.contacter,
          contacterPhone: this.formdata.contacterPhone,
          address: this.formdata.address,
          cityCode: cityCode,
          provinceCode: provinceCode,
          detailedAddress: this.formdata.detailedAddress,
          bugNum: 0
        })
        this.formdata = {}
      } else {
        throw new Error('input validate error')
      }
    },
    async init () {
      this.$loading.show()
      this.datas = []
      const results = await Promise.all([
        this.queryListInfo(),
        this.queryInfoSum()
      ])
      this.datas = results[0]
      this.total = results[1]
      this.$loading.hide()
    },
    async reset () {
      this.$loading.show()
      this.datas = []
      const results = await Promise.all([this.queryListInfo()])
      this.datas = results[0]
      this.$loading.hide()
    },
    async queryListInfo () {
      const res = await this.$tkParse.get('/classes/grainWarehouse', {
        params: {
          order: '-createdAt',
          where: this.filterObj,
          limit: this.pageSize,
          skip: (this.current - 1) * this.pageSize
        }
      })
      return res.data.results
    },
    async queryInfoSum () {
      const res = await this.$tkParse.get('/classes/grainWarehouse', {
        params: {
          where: this.filterObj,
          limit: Number.MAX_SAFE_INTEGER,
          keys: 'objectId'
        }
      })
      return res.data.results.length
    },
    async onChange () {
      this.$loading.show()
      this.datas = await this.queryListInfo()
      this.$loading.hide()
    },
    onShowSizeChange () {
      this.current = 1
      this.init()
    }
  }
}
</script>
<style>
.height-full {
  height: 100%;
}
</style>
